export const defaultCurrency = "EUR";
export const supportedCurrency = [
  { code: "USD", name: "USD ($) - United States Dollar", char: "$" },
  { code: "EUR", name: "EUR (€) - Euro", char: "€" },
  { code: "JPY", name: "JPY (¥) - Japanese Yen", char: "¥" },
  { code: "GBP", name: "GBP (£) - British Pound Sterling", char: "£" },
  { code: "AUD", name: "AUD (A$) - Australian Dollar", char: "A$" },
  { code: "CAD", name: "CAD (C$) - Canadian Dollar", char: "C$" },
];
